import { Component, Input, OnInit } from '@angular/core';
import { ItemBase } from '@src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-itembase';
import { EComWebStorage } from '@src/app/ecom-services/ecom-webstorage.services';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-ecom-item-details-popup',
  templateUrl: './ecom-item-details-popup.component.html',
  styleUrls: ['./ecom-item-details-popup.component.scss']
})
export class EcomItemDetailsPopupComponent implements OnInit {
  @Input() item?: ItemBase;
  @Input() item_pkid?: number;
  @Input() iscvsd_pkid?: number;
  @Input() category_pkid?: number;
  @Input() onClose?: void;

  @Input() upSellId: number = 0;

  constructor(public bsModalRef: BsModalRef, private webstorage: EComWebStorage) { }

  ngOnInit(): void {
  }

  hideModal() {
    this.bsModalRef.hide();
  }

}
